import React, { Component } from "react"
import styled from "styled-components"
import { guid } from "../../util/random_utils"
import { AttendeeUserMatchingItem } from "./attendee_user_matching_item"
import { appStrings } from "../../common/strings/app_strings"
import { checkIfEmailIsValid } from "../../util/onboarding_utils"
import { appConsts } from "../../common/constants/app_consts"
import { makeToast } from "../../util/toast_util"

const {
    attendeeMatching,
    attendeeMatchingDescription,
    addAnother,
    submit,
} = appStrings.connectedApps

const newField = guid => ({
    guid,
    userId: "",
    attendeeEmail: "",
    userFullName: "",
    userPrimaryEmail: "",
    id: null,
})

export class AttendeeUserMatchingController extends Component {
    constructor(props) {
        super(props)
        this.state = {
            attendeeUsers: [],
            showSubmit: false,
        }
    }

    componentDidMount() {
        const { attendeeUsers } = this.props
        const attendeeUsersWithGuids = attendeeUsers.map(t => ({
            ...t,
            name: t.userFullName,
            email: t.userPrimaryEmail,
            guid: guid(),
        }))
        const newAttendeeUsers = [
            ...attendeeUsersWithGuids,
            { ...newField(guid()) },
        ]
        this.setState({ attendeeUsers: [...newAttendeeUsers] })
    }

    componentDidUpdate({ attendeeUsers }) {
        if (this.props.attendeeUsers.length != attendeeUsers.length) {
            this.setState({ showSubmit: false })
        }
    }

    handleAddField = () => {
        const { attendeeUsers } = this.state
        const newAttendeeUsers = [...attendeeUsers, { ...newField(guid()) }]
        this.setState({ attendeeUsers: [...newAttendeeUsers] })
    }

    removeField = idToRemove => {
        const { attendeeUsers } = this.state
        if (attendeeUsers.length === 1) {
            const clearField = newField(idToRemove)
            this.setState({ attendeeUsers: [clearField], showSubmit: true })
            return
        }

        const newAttendeeUsers = attendeeUsers.filter(element => {
            return element.guid !== idToRemove
        })

        const hasInvalidField = this.hasInvalidEmailFields(newAttendeeUsers)
        this.setState({
            attendeeUsers: newAttendeeUsers,
            showSubmit: !hasInvalidField,
        })
    }

    hasInvalidEmailFields = attendeeUsers => {
        const hasInvalidField = attendeeUsers.find(data => {
            const emailIsValid = checkIfEmailIsValid(
                data.attendeeEmail,
                appConsts.regExEmailValidation,
            )
            return !emailIsValid
        })
        return !!hasInvalidField
    }

    updateField = (guid, attendeeEmail, userId) => {
        const newAttendeeUsers = this.state.attendeeUsers.reduce((acc, cur) => {
            return cur.guid === guid
                ? [...acc, { ...cur, userId, attendeeEmail }]
                : [...acc, cur]
        }, [])
        this.setState({ attendeeUsers: newAttendeeUsers })
        const invalidField = newAttendeeUsers.find(field => {
            const isBlank = !field.attendeeEmail && !field.userId
            return isBlank
                ? false
                : field.attendeeEmail === "" || field.userId === ""
        })
        this.setState({ showSubmit: !invalidField })
    }

    handleSubmit = () => {
        const { attendeeUsers } = this.state
        const hasInvalidField = this.hasInvalidEmailFields(attendeeUsers)
        if (hasInvalidField) {
            makeToast("Use valid email address for Attendee email.", "danger")
            return
        }
        this.props.handleUpdateAttendeeUsers(
            this.state.attendeeUsers,
            this.props.configId,
        )
    }

    render() {
        const { attendeeUsers, showSubmit } = this.state
        const { configMembers: members } = this.props
        return (
            <StyleWrapper>
                <h5>{attendeeMatching}</h5>
                <span className="subtext">{attendeeMatchingDescription}</span>
                <div>
                    {attendeeUsers.map(element => {
                        const { guid } = element
                        return (
                            <AttendeeUserMatchingItem
                                key={guid}
                                removeField={this.removeField}
                                userId={element.userId}
                                guid={guid}
                                attendeeEmail={element.attendeeEmail}
                                updateField={this.updateField}
                                members={members}
                            />
                        )
                    })}
                </div>
                <div className="button-wrapper">
                    <span onClick={this.handleAddField} className="link">
                        {addAnother}
                    </span>
                    {showSubmit && (
                        <span className="link" onClick={this.handleSubmit}>
                            {submit}
                        </span>
                    )}
                </div>
            </StyleWrapper>
        )
    }
}

const StyleWrapper = styled.div`
    .subtext {
        font-weight: 400;
        font-size: small;
        margin: 0;
    }
    .add-field {
        height: 25px;
        width: 25px;
        border-radius: 4px;
    }
    .button-wrapper {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 10px;
        .link {
            text-align: right;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/attendee_user_matching_controller.jsx